import React, {Component} from 'react'
import { Checkbox } from 'antd'

class TableHeadBox extends Component {
    render() {
        const {allSelected, toggleSelectAll} = this.props
        return (
            <thead className="TableHeadBox">
            <tr>
                <th>
                    <Checkbox checked={allSelected} onChange={toggleSelectAll}/>
                </th>
                <th>#</th>
                <th>Số gói hàng</th>
                <th>Tổng hàng</th>
                <th>Shipping carrier</th>
                <th>Box name</th>
                <th>Trạng thái</th>
                <th>Ngày khởi tạo</th>
                <th>Ngày đóng thùng</th>
                <th>Ngày ship đi</th>
                <th>Cân nặng thực tế</th>
                <th>Thông tin ship</th>
                <th>Mã đơn FFM</th>
                <th></th>
            </tr>
            </thead>
        )
    }
}

export default TableHeadBox
